module.exports = __webpack_public_path__ + "img/3.990e3135.jpg";